"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class App {
    constructor(rootElement) {
        if (!rootElement) {
            return;
        }
    }
}
exports.default = App;
